import React from 'react';
import './utils/metaPixel'; // Auto-inits pixel + fires PageView on load
import { motion } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { PainMirror } from './components/PainMirror';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { ProtocolReveal } from './components/ProtocolReveal';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForWhom } from './components/ForWhom';
import { HowToUse } from './components/HowToUse';
import { FAQ } from './components/FAQ';
import { OfferCTA } from './components/OfferCTA';
import { FooterClose } from './components/FooterClose';
export function App() {
  return <main className="min-h-screen w-full bg-[#1a2332] overflow-x-hidden selection:bg-[#c9a04e] selection:text-[#1a2332]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainMirror data-id="element-2" />
      <OldSolutionsFail data-id="element-3" />
      <ProtocolReveal data-id="element-4" />
      <WhatsIncluded data-id="element-5" />

      {/* Image break - kit in use, peaceful sleep */}
      <div className="relative w-full overflow-hidden" data-id="element-6">
        <motion.img src="https://cdn.magicpatterns.com/uploads/iJ324PWUVVTztYuuht8VPd/foto3-sales_letter.png" alt="Mujer durmiendo tranquila con la guía de descanso nocturno en la mesita" className="w-full object-cover object-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-7" />
        <div className="absolute inset-0 bg-[#1a2332]/30" data-id="element-8" />
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-[#1a2332] to-transparent" data-id="element-9" />
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#1a2332] to-transparent" data-id="element-10" />
      </div>

      <ForWhom data-id="element-11" />
      <HowToUse data-id="element-12" />
      <FAQ data-id="element-13" />
      <OfferCTA data-id="element-14" />
      <FooterClose data-id="element-15" />
    </main>;
}